import { useSocket } from "context/socket";
import { useAppServices } from "hook/services";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function ConversationData() {
  const AppService = useAppServices();
  const socket = useSocket();
  const { locationId } = useParams();
  const [conversations, setConversations] = useState<any>([]);
    const [messages, setMessages] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [messagesLoading, setMessagesLoading] = useState<boolean>(false);
 
 
  const getConversations = async () => {
    setLoading(true);
    try {
      const { response, error } = await AppService.conversation.filter({
        query: `locationId=${locationId}`,
      });

      if (response && response.data) {
        setConversations(response.data);

        // Update pagination info from API response
        if (response.pagination) {
        }
      } else {
        setConversations([]);
      }
    } catch (error) {
      console.error("Error fetching Conversations:", error);
      setConversations([]);
    } finally {
      setLoading(false);
    }
  };
   const getMessages = async (contactId:string) => {
    setMessagesLoading(true)
    const { response } = await AppService.message.filter({
      query: `contactId=${contactId}`,
    });
    if (response) {
      setMessages(response.data);
    }
    setMessagesLoading(false)
  };

  let pgaeLoad = true;
  useEffect(() => {
    // Prevent double calls in development (Strict Mode)
    if (pgaeLoad) {
      getConversations();
      pgaeLoad = false;
    }
  }, []);
  useEffect(() => {
    if (!socket) return;
    const handleMessageResponse = (data: any) => {
      setMessages((prev) => [...prev, data]);
    };
    socket.on("conversationCreated", getConversations);
    socket.on("messageResponse", handleMessageResponse);

    return () => {
      socket.off("conversationCreated", getConversations);
      socket.off("messageResponse", handleMessageResponse);
    };
  }, [socket]);
  return {
    loading: loading,
    conversations: conversations,
    messages,
    getMessages,
    messagesLoading
  };
}